import {gql, useSubscription} from "@apollo/client";
import React from "react";
import {getCallEvent} from "./types/getCallEvent";

const CALL_EVENT_SUBSCRIPTION = gql`
    subscription getCallEvent {
        onCallEvent {
            event
            state
            timestamp
            sequence
            callId
            otherLegCallId
            destination
            leg {
                direction
                deviceDirection
                presenceId
            }
            caller {
                name
                number
            }
            callee {
                name
                number
            }
        }
    }`

/**
 * The live-call stream of a company on an offhook instance. Its FusionPBX
 * counterpart is ChannelStateEvent; CallStateStream picks between them.
 */
export default function CallEvent(props: { dispatch: React.Dispatch<any>, children: React.ReactNode }) {
    const { dispatch } = props;

    useSubscription<getCallEvent>(
        CALL_EVENT_SUBSCRIPTION,
        {
            onData: ({ data }) => {
                if (data.data?.onCallEvent) {
                    dispatch({ type: 'CALL_EVENT', data: data.data.onCallEvent });
                }
            },
        }
    );

    return <>{props.children}</>

}
